import { Navigate, Route } from 'react-router-dom'
import { Routes } from 'react-router-dom'

import { BASE_ROUTE } from 'consts/routes'
import Layout from 'containers'

const AppRoutes = () => {
  return (
    <Routes>
      <Route path={BASE_ROUTE} element={<Layout />}>
        <Route path="*" element={<Navigate to="" replace />} />
      </Route>
      <Route path="*" element={<Navigate to="/new" />} />
    </Routes>
  )
}

export default AppRoutes
